<template>
    <div>
        <div v-for="(item,index) in list">
            <p class="title">{{$store.state.product[item].headline}}</p>
            <ul class="list">
                <li v-for="(pitem,pindex) in $store.state.product[item].list" @click="goDetails(pitem.id)">
                    <img :src="pitem.img" />
                    <p>{{pitem.name}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            product: [],
        }
    },

    props: ['list'],

    mounted() {
    },

    methods: {
        goDetails(id) {
            this.$router.replace({ path: '/productDetails', query: { id: id } });
        }
    },

    computed: {
        getId: function () {
            return this.$store.state.productId;
        }
    },

    components: {
    },
}

</script>

<style scoped lang='less'>
.title {
    width: 900px;
    margin: 0 auto;
    line-height: 60px;
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #f4f4f4;
}

.list {
    width: 920px;
    margin: 0 auto;
    li {
        display: inline-block;
        vertical-align: top;
        margin: 23px 10px;
        width: 210px;
        cursor: pointer;
        img {
            width: 210px;
            height: 200px;
        }
        p {
            text-align: center;
            border: 1px solid #eeeeee;
            font-size: 14px;
            line-height: 50px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/productItem.vue